import pi1 from "../../images/avatars/profile-icon-01.svg?react"
import pi2 from "../../images/avatars/profile-icon-02.svg?react"
import pi3 from "../../images/avatars/profile-icon-03.svg?react"
import pi4 from "../../images/avatars/profile-icon-04.svg?react"
import pi5 from "../../images/avatars/profile-icon-05.svg?react"
import pi6 from "../../images/avatars/profile-icon-06.svg?react"
import pi7 from "../../images/avatars/profile-icon-07.svg?react"
import pi8 from "../../images/avatars/profile-icon-08.svg?react"
import pi9 from "../../images/avatars/profile-icon-09.svg?react"
import pi13 from "../../images/avatars/profile-icon-13.svg?react"
import pi14 from "../../images/avatars/profile-icon-14.svg?react"
import pi15 from "../../images/avatars/profile-icon-15.svg?react"
import pi19 from "../../images/avatars/profile-icon-19.svg?react"
import pi20 from "../../images/avatars/profile-icon-20.svg?react"
import pi21 from "../../images/avatars/profile-icon-21.svg?react"
import pi49 from "../../images/avatars/profile-icon-49.svg?react"
import pi50 from "../../images/avatars/profile-icon-50.svg?react"
import pi51 from "../../images/avatars/profile-icon-51.svg?react"
import pi52 from "../../images/avatars/profile-icon-52.svg?react"
import pi53 from "../../images/avatars/profile-icon-53.svg?react"
import pi54 from "../../images/avatars/profile-icon-54.svg?react"
import pi55 from "../../images/avatars/profile-icon-55.svg?react"
import pi56 from "../../images/avatars/profile-icon-56.svg?react"
import pi57 from "../../images/avatars/profile-icon-57.svg?react"
import pi58 from "../../images/avatars/profile-icon-58.svg?react"
import pi59 from "../../images/avatars/profile-icon-59.svg?react"
import pi60 from "../../images/avatars/profile-icon-60.svg?react"
import pi61 from "../../images/avatars/profile-icon-61.svg?react"
import pi62 from "../../images/avatars/profile-icon-62.svg?react"
import pi63 from "../../images/avatars/profile-icon-63.svg?react"
import pi64 from "../../images/avatars/profile-icon-64.svg?react"
import pi65 from "../../images/avatars/profile-icon-65.svg?react"
import pi66 from "../../images/avatars/profile-icon-66.svg?react"
import pi67 from "../../images/avatars/profile-icon-67.svg?react"
import pi68 from "../../images/avatars/profile-icon-68.svg?react"
import pi69 from "../../images/avatars/profile-icon-69.svg?react"
import pi70 from "../../images/avatars/profile-icon-70.svg?react"

const avatars = {
  "sun": {
    id: "sun",
    image: pi65
  },
  "moon": {
    id: "moon",
    image: pi66
  },
  "star": {
    id: "star",
    image: pi68
  },
  "saturn": {
    id: "saturn",
    image: pi67
  },
  "walrus": {
    id: "walrus",
    image: pi62
  },
  "dove": {
    id: "dove",
    image: pi70
  },
  "bear": {
    id: "bear",
    image: pi69
  },
  "flower": {
    id: "flower",
    image: pi63
  },
  "eye": {
    id: "eye",
    image: pi2
  },
  "health": {
    id: "health",
    image: pi7
  },
  "skull": {
    id: "skull",
    image: pi1
  },
  "diamond": {
    id: "diamond",
    image: pi61
  },
  "compass": {
    id: "compass",
    image: pi8
  },
  "key": {
    id: "key",
    image: pi3
  },
  "boomerang": {
    id: "boomerang",
    image: pi9
  },
  "sword": {
    id: "sword",
    image: pi4
  },
  "knight": {
    id: "knight",
    image: pi5
  },
  "dark-knight": {
    id: "dark-knight",
    image: pi6
  },
  "strawberry": {
    id: "strawberry",
    image: pi19
  },
  "orange": {
    id: "orange",
    image: pi20
  },
  "cherry": {
    id: "cherry",
    image: pi21
  },
  "plant": {
    id: "plant",
    image: pi64
  },
  "guitar": {
    id: "guitar",
    image: pi13
  },
  "piano": {
    id: "piano",
    image: pi14
  },
  "music": {
    id: "music",
    image: pi15
  },
  "box": {
    id: "box",
    image: pi49
  },
  "dots": {
    id: "dots",
    image: pi50
  },
  "bullseye": {
    id: "bullseye",
    image: pi51
  },
  "happy": {
    id: "happy",
    image: pi57
  },
  "sadness": {
    id: "sadness",
    image: pi60
  },
  "wink": {
    id: "wink",
    image: pi53
  },
  "joy": {
    id: "joy",
    image: pi59
  },
  "wow": {
    id: "wow",
    image: pi52
  },
  "ohh": {
    id: "ohh",
    image: pi55
  },
  "sleepy": {
    id: "sleepy",
    image: pi56
  },
  "sick": {
    id: "sick",
    image: pi54
  },
  "shrek": {
    id: "shrek",
    image: pi58
  },
  "target": {
    id: "target",
    image: pi51
  }
}

export const getAvatar = (id) => avatars[id] || avatars["happy"]
const objectToArray = (obj) => Object.keys(obj).map((key) => obj[key])

export const getAvatars = () => objectToArray(avatars)
